// Note: There are langKeys associated with these constants.
export const AdAccountErrorStates = {
  INACTIVE: 'INACTIVE',
  NONE: 'NONE',
  PERMISSIONS_NEEDED: 'PERMISSIONS_NEEDED'
};

// Note: There are langKeys associated with these constants.
export const CreateAudienceErrorType = {
  ADVERTISER_NOT_WHITELISTED_FOR_USING_UPLOADED_DATA: 'ADVERTISER_NOT_WHITELISTED_FOR_USING_UPLOADED_DATA',
  CUSTOM_AUDIENCE_TERMS_NOT_ACCEPTED: 'CUSTOM_AUDIENCE_TERMS_NOT_ACCEPTED',
  SEED_AUDIENCE_TOO_SMALL: 'SEED_AUDIENCE_TOO_SMALL',
  SOURCE_IS_TOO_SMALL: 'SOURCE_IS_TOO_SMALL',
  UNTRUSTWORTHY_PORTAL: 'UNTRUSTWORTHY_PORTAL'
};
export const Networks = {
  ALL: 'ALL',
  ADWORDS: 'ADWORDS',
  FACEBOOK: 'FACEBOOK',
  LINKEDIN: 'LINKEDIN'
};